import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { YshDotsComponent } from "../ysh-dots/ysh-dots.component";

export type YshButtonTheme = 'blue' | 'coral' | 'shadow' | 'smoke' | 'white' | 'clear';
export type YshButtonSize = 'small' | 'large';

@Component({
    selector: 'ysh-button',
    templateUrl: './ysh-button.component.html',
    styleUrl: './ysh-button.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        YshDotsComponent,
    ]
})
export class YshButtonComponent {
  @Input() theme: YshButtonTheme = 'blue';
  @Input() size: YshButtonSize = 'large';
  @Input() label?: string;
  /** Name from Material Icons */
  @Input() icon?: string;
  /** Show animated loading spinner */
  @Input() loading?: boolean;
  @Input() disabled?: boolean;
}
